import { render, staticRenderFns } from "./yingshou.vue?vue&type=template&id=174ed3a0&scoped=true"
import script from "./yingshou.vue?vue&type=script&lang=js"
export * from "./yingshou.vue?vue&type=script&lang=js"
import style0 from "./yingshou.vue?vue&type=style&index=0&id=174ed3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ed3a0",
  null
  
)

export default component.exports